import styled from 'styled-components';

export const PeriodSelect = styled.select`
  min-width: 120px;
`;
